export const ERROR_QUERY_PARAM_KEY = 'error_type'

// Payment errors namespace (100xxx)
export const DISALLOW_CONNECT_NON_WHITELIST_STRIPE_ACCOUNT = '100001'

// GoGov Bad Request error messages
export const GO_VALIDATION_ERROR_MESSAGE =
  'Validation error when claiming GoGov link'

export const GO_ALREADY_EXIST_ERROR_MESSAGE = 'GoGov link already exists'
